import { WithRouteData } from '../render-routes';
import { SuperAdminPage as SuperAdmin } from '../pages';
import { IPage } from '../pages/types';
import { FC } from 'react';

export const SuperAdminPage: FC<IPage> = (props) => <SuperAdmin {...props} />;

export default WithRouteData(SuperAdminPage);
